import { create } from 'zustand';

type GlobalSearchState = {
  isOpen: boolean;
  open: () => void;
  close: () => void;
  toggle: () => void;
};

/**
 * Global search (⌘K) open-state. A store rather than local state because the
 * triggers and the modal live in different subtrees: the search button sits in
 * the per-page header, the modal is mounted once by LayoutContainer.
 *
 * Deliberately not persisted — a search panel that reopens itself on reload is
 * a bug, not a remembered preference (unlike the sidebar, see drawer.store).
 */
export const useGlobalSearchStore = create<GlobalSearchState>((set) => ({
  isOpen: false,
  open: () => set({ isOpen: true }),
  close: () => set({ isOpen: false }),
  toggle: () => set((s) => ({ isOpen: !s.isOpen })),
}));
